import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import {
  GetUserOrdersDetailsRequestType,
  GetUserOrdersDetailsWithFiltersResponseType
} from '../../../services/PaymentServices/APIService/types';
import { getAPIErrorMessage } from '../../../utils/ApiErrorUtils';

import usePaymentServices from '../usePaymentServices';

interface UseGetUserOrdersDetailsWithFiltersInterface {
  getUserOrdersDetailsWithFiltersApi: UseMutateAsyncFunction<
    GetUserOrdersDetailsWithFiltersResponseType,
    Error,
    GetUserOrdersDetailsRequestType,
    unknown
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserOrdersDetailsWithFiltersApi =
  (): UseGetUserOrdersDetailsWithFiltersInterface => {
    const { paymentServices } = usePaymentServices();

    const getUserOrdersDetailsWithFilters = (
      requestObject: GetUserOrdersDetailsRequestType
    ) => {
      return paymentServices.getUserOrdersDetailsWithFilters(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      getUserOrdersDetailsWithFilters,
      {
        mutationKey: ['getUserOrdersDetailsWithFiltersApi']
      }
    );

    return {
      getUserOrdersDetailsWithFiltersApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetUserOrdersDetailsWithFiltersApi };
